import { ApiUser } from 'api/types/ApiUserEnvironment';

export function getUserType(user: ApiUser | null) {
  if (user) {
    if (user.permissions.includes('staff')) {
      return 'Staff';
    }

    if (user.orgs && user.orgs.length > 0) {
      let orgUserType = 'Org Admin';
      user.orgs.forEach((org) => {
        if (org.hasGradProgram) {
          orgUserType = 'Grad Admin';
        }
      });
      return orgUserType;
    }

    return 'Logged In User';
  }

  return 'Logged Out User';
}
